import _ from 'lodash'
import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './rfidReaders.html'

/**
 * Administer RFID Readers route
 *
 * @namespace routes.AdminRfidReaders
 * @type {TmrRoute}
 */
export const route = {
  name: 'devices.rfidReaders.list',
  label: 'ADMIN.RFIDREADERS.TITLE',
  url: '/rfidReaders',
  component: 'tmrAdminRfidReaders',
  weight: 1,
  resourceType: 'RfidReader',
  resourceList: {
    searchParameters: ['code', 'description', 'type', 'place.id', 'ipAddress'],
  },
  resolve: {
    rfidReaderTypes: /*@ngInject*/ tmrRfidReaderTypes =>
      _.mapValues(tmrRfidReaderTypes, 'label'),
  },
}

/**
 * Component for {@link routes.tmrAdminRfidReaders Administer RFID Readers route}
 *
 * @type {ngComponent}
 */
export const tmrAdminRfidReaders = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings({
    rfidReaderTypes: '<',
  }),
}
